var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_6531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.999 13.8643C29.2501 14.1961 28.4557 14.4138 27.6423 14.5103C28.4896 14.0026 29.1401 13.1985 29.4464 12.2405C28.641 12.7184 27.7598 13.0551 26.8409 13.2361C26.0924 12.4387 25.0261 11.9404 23.8458 11.9404C21.5797 11.9404 19.7425 13.7774 19.7425 16.0432C19.7425 16.3648 19.7788 16.6779 19.8487 16.9782C16.4386 16.8071 13.4151 15.1737 11.3913 12.6915C11.0382 13.2974 10.8358 14.0023 10.8358 14.7541C10.8358 16.1775 11.5603 17.4333 12.6612 18.169C12.0096 18.1486 11.3723 17.9727 10.8026 17.6558C10.8024 17.673 10.8024 17.6902 10.8024 17.7074C10.8024 19.6953 12.2168 21.3536 14.0938 21.7305C13.4896 21.8948 12.8558 21.9189 12.2408 21.8008C12.7629 23.4308 14.2783 24.6169 16.0738 24.6501C14.6695 25.7505 12.9002 26.4064 10.9779 26.4064C10.6466 26.4064 10.32 26.387 9.99902 26.3491C11.8149 27.5132 13.9717 28.1924 16.2889 28.1924C23.8363 28.1924 27.9634 21.9406 27.9634 16.519C27.9634 16.341 27.9595 16.1641 27.9515 15.9882C28.7548 15.4075 29.4482 14.6883 29.999 13.8643Z",
    fill: "#46B1DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_6531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.3265,
    fill: "white",
    transform: "translate(9.99902 11.875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f71b04f57761c42d6de9c7a1a11e427a.svg";
export { ForwardRef as ReactComponent };